import React, { useState } from "react";
import { useSelector } from "react-redux";

const C_V_TEXT = React.memo(
  ({
    value,
    tempValue,
    isEditing,
    onChange,
    onBlur,
    onKeyDown,
    inPopup = false,
  }) => {
    const [isFocused, setIsFocused] = useState(false);

    const properties_state = useSelector((state) => state.properties);

    // 1. POPUP MODE
    if (inPopup) {
      const mode_map = properties_state.mode_map; //editor || viewer
      return (
        <div
          style={{ display: "flex", flexDirection: "column", width: "100%" }}
        >
          <input
            disabled={mode_map !== "editor"}
            type="text"
            value={tempValue}
            onChange={onChange}
            onBlur={(e) => {
              setIsFocused(false);
              if (onBlur) onBlur(e);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === "Escape") {
                // Force the input to lose focus so the helper text disappears
                e.target.blur();
              }
              // Pass the event up to the parent to handle the actual save
              if (onKeyDown) onKeyDown(e);
            }}
            onFocus={() => setIsFocused(true)}
            className="input"
            style={{ width: "100%", boxSizing: "border-box" }}
          />
          {isFocused && (
            <p
              className="text_small"
              style={{ margin: "4px 0 0 0", color: "#666" }}
            >
              Press Enter to save
            </p>
          )}
        </div>
      );
    }

    // 2. EDIT MODE
    if (isEditing) {
      return (
        <input
          autoFocus
          type="text"
          value={tempValue}
          onChange={onChange}
          onBlur={onBlur}
          onKeyDown={onKeyDown}
          className="input_table"
        />
      );
    }

    // 3. VIEW MODE (The Performance Workhorse)
    // Stripped of inline styles and ellipsis for maximum render speed
    return (
      <span title={value} className="cell_text_fast">
        {value || "-"}
      </span>
    );
  },
  (prevProps, nextProps) => {
    // THE ARMOR: Explicitly ignore function props (onChange, onBlur)
    // so the parent's inline arrow functions cannot break our memoization.
    return (
      prevProps.value === nextProps.value &&
      prevProps.isEditing === nextProps.isEditing &&
      prevProps.tempValue === nextProps.tempValue &&
      prevProps.inPopup === nextProps.inPopup
    );
  },
);

export default C_V_TEXT;
